import React from 'react';
function VenuemonkBenefits(props) {

  return (
      <div className={"d-flex justify-content-center align-items-center"} style={{gap: "10px"}}>
        <img width="6%" src={props.image}/>
        <p className={"venue-title"} style={{margin: 0, fontWeight: 500}}>{props.title}</p>
      </div>
  );

}

export default VenuemonkBenefits;
